import { get } from 'lodash-es';
import { STATUS_SUCCESS, STATUS_ERROR, STATUS_LOADING } from 'store/status';

import {
  CLEAR_DRAFT_PREVIEW,
  GENERATE_DRAFT_PREVIEW,
  GET_DRAFT_PREVIEW,
} from 'modules/v2/draft/store/constants';

import { preview as initialState } from 'modules/v2/draft/store/reducers/initialState';

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${GENERATE_DRAFT_PREVIEW}_REQUESTED`:
    case `${GET_DRAFT_PREVIEW}_REQUESTED`: {
      return {
        ...state,
        data: null,
        status: STATUS_LOADING,
      };
    }

    case `${GENERATE_DRAFT_PREVIEW}_FAILED`:
    case `${GET_DRAFT_PREVIEW}_FAILED`: {
      return {
        ...state,
        status: STATUS_ERROR,
      };
    }

    case `${GENERATE_DRAFT_PREVIEW}_SUCCEEDED`:
    case `${GET_DRAFT_PREVIEW}_SUCCEEDED`: {
      const data = get(action, ['payload'], null);

      return {
        ...state,
        data,
        status: STATUS_SUCCESS,
      };
    }

    case CLEAR_DRAFT_PREVIEW: {
      return { ...initialState };
    }

    default:
      return state;
  }
};

export default reducer;
